import React from 'react';
import { Grid } from '@mui/material';

import { TextField } from '@occc-app/design-system';

import { FormCardLayout } from './FormCardLayout';

export const AudienceInfoFormContent: React.FC = () => {
  return (
    <FormCardLayout title='Audience Information' rootProps={{ elevation: 2 }}>
      <Grid container spacing={3} px={3}>
        <Grid item xs={12} md={6}>
          <TextField name='name' label='Name' required />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField name='description' label='Description' multiline required />
        </Grid>
      </Grid>
    </FormCardLayout>
  );
};
